import React from 'react';
import get from 'lodash/get';
import useTitle from 'react-use/lib/useTitle';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useStoreActions, useStoreState } from 'app/state/store/hooks';
import { getAPIFormattedFilters } from 'app/utils/getAPIFormattedFilters';
import { SectorsFragmentLayout } from 'app/fragments/sectors-fragment/layout';
import {
  SwitchMapState,
  selectedFilterAtom,
  transactionTypeAtom,
} from 'app/state/recoil/atoms';

interface SectorsFragmentProps {
  pageParam: string;
  detailBaseFilter: string;
}

const sunburstInitData = {
  title: '',
  color: '',
  children: [],
};

const SectorsFragment = (props: SectorsFragmentProps) => {
  useTitle(`${document.title} sectors`);

  const [selected, setSelected] = React.useState('');
  const [prevSelections, setPrevSelections] = React.useState<string[]>([]);
  const [active] = useRecoilState(SwitchMapState);
  const [selectedFilters, _] = useRecoilState(selectedFilterAtom);
  const transactionType = useRecoilValue(transactionTypeAtom);

  const sunburstData = useStoreState((state) => ({
    count: get(state.sunburst, 'data.count', 0),
    vizData: get(state.sunburst, 'data.vizData', sunburstInitData),
  }));
  const sunburstAction = useStoreActions((actions) => actions.sunburst.fetch);

  function callAction() {
    const filters = getAPIFormattedFilters(selectedFilters);
    sunburstAction({
      values: {
        filters: {
          ...filters,
          [props.detailBaseFilter]: [props.pageParam],
        },
        transactionTypeCode: transactionType.code,
      },
    });
  }

  React.useEffect(() => {
    callAction();
  }, [props.pageParam, selectedFilters, transactionType]);

  return (
    <SectorsFragmentLayout
      showViz={active}
      pageParam={props.pageParam}
      sunburstCount={sunburstData.count}
      sunburstData={sunburstData.vizData}
      detailBaseFilter={props.detailBaseFilter}
      selected={selected}
      setSelected={setSelected}
      prevSelections={prevSelections}
      setPrevSelections={setPrevSelections}
    />
  );
};

export default SectorsFragment;
